<template>
  <div class="ws-stepper">
    <v-stepper
      :value="value"
      @change="$emit('input',$event)"
      class="elevation-0 transparent"
    >
      <v-stepper-header class="elevation-0">
        <template v-for="(stepItem,stepIndex) in stepperSteps">
          <v-stepper-step
            :key="stepIndex"
            :editable="stepItem.editable"
            :step="stepIndex+1"
          >{{stepItem.title}}</v-stepper-step>
          <v-divider
            v-if="stepIndex!==stepperSteps.length-1"
            :key="stepIndex+'divider'"
          ></v-divider>
        </template>
      </v-stepper-header>
      <v-stepper-items class="mt-5">
        <v-stepper-content
          v-for="(stepItem,stepIndex) in stepperSteps"
          :key="stepIndex"
          :step="stepIndex+1"
          class="pa-0"
        >
          <slot :name="`step-content-${stepIndex+1}`"></slot>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<script>
export default {
  name: "WsStepper",
  methods: {},
  computed: {},
  props: {
    stepperSteps: {
      type: Array,
    },
    value: {
      type: Number,
      default: 1,
    },
  },
};
</script>